import * as React from "react";
const SvgFiRrShuttleVan = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-shuttle-van_svg__a)">
      <path
        fill="#062147"
        d="m23.4 10.43-2.43-5.46A5 5 0 0 0 16.4 2H5a5.006 5.006 0 0 0-5 5v8a4.01 4.01 0 0 0 3 3.873v.627a3.5 3.5 0 1 0 7 0V19h4v.5a3.5 3.5 0 0 0 7 0v-.627A4.006 4.006 0 0 0 24 15v-1.727a6.9 6.9 0 0 0-.6-2.843m-4.258-4.648L21.017 10H14V4h2.4a3 3 0 0 1 2.742 1.782M8 10V4h4v6zM5 4h1v6H2V7a3 3 0 0 1 3-3m3 15.5a1.5 1.5 0 0 1-3 0V19h3zm9.5 1.5a1.5 1.5 0 0 1-1.5-1.5V19h3v.5a1.5 1.5 0 0 1-1.5 1.5m4.5-6a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2v-3h19.836c.11.415.165.843.164 1.273z"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-shuttle-van_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrShuttleVan;
